import React, { useState, useEffect } from "react";
import "./CommentPopup.css";

export default function CommentPopup({
  isOpen,
  onClose,
  onSubmit,
  imageId,
  profile_img,
  x,
  y,
}) {
  const [parts, setParts] = useState([{ title: "Allgemein", text: "" }]);
  const [detectedBuzzword, setDetectedBuzzword] = useState(null);

  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (isOpen) {
      setParts([{ title: "Allgemein", text: "" }]);
      setDetectedBuzzword("");
    }
  }, [isOpen]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  const [user, setUser] = useState(null);
  useEffect(() => {
    fetch(`${API_URL}/api/me`, { credentials: "include" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        data && setUser(data);
      });
  }, []);

  function handlePartChange(index, field, value) {
    const buzzwords = [
      "doof",
      "blöd",
      "dumm",
      "katastrophal",
      "lächerlich",
      "hässlich",
      "bescheuert",
      "idiotisch",
      "debil",
      "armselig",
      "peinlich",
      "grottig",
      "grässlich",
      "hirnlos",
      "unfähig",
      "nicht zu gebrauchen",
      "totaler Mist",
      "Bullshit",
      "Cringe",
    ];
    let foundWord = null;

    if (typeof value === "string") {
      for (let word of buzzwords) {
        const regex = new RegExp(`\\b${word}\\b`, "i");
        if (regex.test(value)) {
          foundWord = word;
          break;
        }
      }
    }

    setDetectedBuzzword(foundWord);

    setParts((prevParts) => {
      const newParts = [...prevParts];
      newParts[index] = { ...newParts[index], [field]: value };
      return newParts;
    });
  }

  const addPart = () => {
    setParts([...parts, { title: "Allgemein", text: "" }]);
  };

  const removePart = (index) => {
    const updated = [...parts];
    updated.splice(index, 1);
    setParts(updated);
  };

  const handleSubmit = () => {
    const validParts = parts.filter(
      (p) => p.title.trim() !== "" || p.text.trim() !== ""
    );
    if (validParts.length === 0) return;

    onSubmit({ imageId, profile_img, x, y, parts: validParts });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content flex flex-column">
        <span className="icon material-icons align-end" onClick={onClose}>
          close
        </span>
        <div className="flex items-center" style={{ gap: "1em" }}>
          <img
            src={`/semesterprojekt/backend/uploads/profileImg/${user.profile_img}`}
            alt="Profilbild"
            style={{
              aspectRatio: "1/1",
              maxHeight: "3em",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <span>{user.username}</span>
        </div>
        <div>
          {parts.map((part, index) => (
            <>
              <div className="comment-part-wrapper" key={index}>
                {parts.length > 1 && (
                  <span
                    className="material-icons align-center whiteBG remove-icon"
                    title="Element entfernen"
                    onClick={() => removePart(index)}
                  >
                    delete
                  </span>
                )}
                <div className="comment-part">
                  <select
                    value={part.title}
                    onChange={(e) =>
                      handlePartChange(index, "title", e.target.value)
                    }
                  >
                    <option value="Allgemein">Allgemein</option>
                    <option value="Frage">Frage</option>
                    <option value="Grafische Elemente">
                      Grafische Elemente
                    </option>
                    <option value="Typografie & Font">Typografie & Font</option>
                    <option value="Farbwahl">Farbwahl</option>
                    <option value="Bildformat">Bildformat</option>
                    <option value="Layout & Struktur">Layout & Struktur</option>
                    <option value="Usability & Benutzerführung">
                      Usability & Benutzerführung
                    </option>
                  </select>
                  <textarea
                    placeholder={`${index + 1}. Kommentar`}
                    value={part.text}
                    rows="5"
                    onChange={(e) =>
                      handlePartChange(index, "text", e.target.value)
                    }
                  />
                </div>
              </div>
            </>
          ))}
        </div>

        <div className="horizontal-line align-center">
          <span className="line" />
          <span
            className="icon material-icons"
            title="Weiteren Kommentar hinzufügen"
            onClick={addPart}
          >
            add
          </span>
          <span className="line" />
        </div>

        <div className="popup-buttons flex flex-row">
          <div className="flex flex-row items-center" style={{ gap: "1em" }}>
            <div onClick={handleSubmit} className="buttonClass">
              Absenden
            </div>
            <div onClick={onClose} className="buttonClass">
              Abbrechen
            </div>
          </div>
        </div>
        <span
          style={{ color: "red", fontSize: "0.7em", margin: "0.7em 1em 0 1em" }}
        >
          {detectedBuzzword &&
            `"${detectedBuzzword}" erkannt -> Denke daran, konstruktives Feedback zu geben ohne zu beleidigen.`}
        </span>
      </div>
    </div>
  );
}
